import * as React from "react";
import { isMarketType, getDictPhrase, prepareSelections, getUniqueClassName } from "../../../../../../helpers";
import { BetBtnAmerican } from "../../../../components";
export const renderMiniBetButtonsAmerican = (cardProps, market, componentPrefix) => {
    const selections = prepareSelections(market, cardProps.event.isTeamSwap);
    const marketUniqueClass = getUniqueClassName(market.id, "market");
    ;
    return (React.createElement("div", { key: `${componentPrefix}__${market.id}`, className: `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__section--${market.template} ${marketUniqueClass}`, "data-uat": `div-ev-list-${componentPrefix}-section` }, selections && selections.map((s, index) => {
        const betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
        const name = getSelectionName(market, s, cardProps.isDesktop, cardProps.dict);
        const selectionUniqueClass = getUniqueClassName(s.id, "selection");
        return (React.createElement(BetBtnAmerican, { key: `${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`, isDisabled: s.isDisabled, classNames: `${betslipModifier} ${selectionUniqueClass}`, handler: () => cardProps.handlers.betButton(market, s), text: name, point: s.pointsText, odd: s.odds, trueOdds: s.trueOdds, hideLowOdds: cardProps.hideLowOdds }));
    })));
};
const getSelectionName = (market, selection, isDesktop, dict) => {
    if (!selection.outcomeType) {
        return "";
    }
    if (isMarketType(market.marketType.id, "ML") && !isDesktop) {
        return "";
    }
    if (isMarketType(market.marketType.id, "OU")) {
        return getDictPhrase(dict, `AmericanBtn${selection.outcomeType}`);
    }
    return "";
};
//# sourceMappingURL=renderMiniBetButtonsAmerican.js.map